import axiosInstance from '../axios/axiosInstance';

export const getAllBids = () => axiosInstance.get(`/account/mybids`);
export const getAllMyWons = () => axiosInstance.get(`/account/mywon`);
